// Use environment variables for API URL with fallback to localhost for development
const apiBaseUrl = import.meta.env.VITE_API_URL || "http://localhost:8000/api";

export const API_BASE_URL = apiBaseUrl;
